import { render, staticRenderFns } from "./ActivityTemplatePage.vue?vue&type=template&id=1dfa8c04&scoped=true"
import script from "./ActivityTemplatePage.vue?vue&type=script&lang=js"
export * from "./ActivityTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./ActivityTemplatePage.vue?vue&type=style&index=0&id=1dfa8c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa8c04",
  null
  
)

export default component.exports